"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../ThemeProvider");

var _utils = require("../../utils");

var _utils2 = require("../../utils/utils");

var _MenuItem = _interopRequireDefault(require("./MenuItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var POSITION = {
  AUTO: 'auto',
  STATIC: 'static',
  TOP_LEFT: 'topLeft',
  TOP_RIGHT: 'topRight',
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_RIGHT: 'bottomRight'
};

var Menu =
/*#__PURE__*/
function (_Component) {
  _inherits(Menu, _Component);

  function Menu() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Menu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleDocumentClick", function (event) {
      if (_this.state.active && !_utils.events.targetIsDescendant(event, _reactDom["default"].findDOMNode(_assertThisInitialized(_this)))) {
        _this.setState({
          active: false,
          rippled: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (item, event) {
      var _item$props = item.props,
          value = _item$props.value,
          onClick = _item$props.onClick;
      if (onClick) event.persist();

      _this.setState({
        active: false
      }, function () {
        if (onClick) onClick(event);
        if (_this.props.onSelect) _this.props.onSelect(value);
      });
    });

    return _this;
  }

  _createClass(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.positionTimeoutHandle = setTimeout(function () {
        var _this2$menuNode$getBo = _this2.menuNode.getBoundingClientRect(),
            width = _this2$menuNode$getBo.width,
            height = _this2$menuNode$getBo.height;

        var position = _this2.props.position === POSITION.AUTO ? _this2.calculatePosition() : _this2.props.position;

        _this2.setState({
          position: position,
          width: width,
          height: height
        });
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (this.props.position !== nextProps.position) {
        var position = nextProps.position === POSITION.AUTO ? this.calculatePosition() : nextProps.position;
        this.setState({
          position: position
        });
      }
      /**
       * If the menu is going to be activated via props and its not active, verify
       * the position is appropriated and then show it recalculating position if its
       * wrong. It should be shown in two consecutive setState.
       */


      if (!this.props.active && nextProps.active && !this.state.active) {
        if (nextProps.position === POSITION.AUTO) {
          var _position = this.calculatePosition();

          if (this.state.position !== _position) {
            this.setState({
              position: _position,
              active: false
            }, function () {
              _this3.activateTimeoutHandle = setTimeout(function () {
                _this3.show();
              }, 20);
            });
          } else {
            this.show();
          }
        } else {
          this.show();
        }
      }
      /**
       * If the menu is being deactivated via props and the current state is
       * active, it should be hid.
       */


      if (this.props.active && !nextProps.active && this.state.active) {
        this.hide();
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (!this.state.active && nextState.active) {
        _utils.events.addEventsToDocument({
          click: this.handleDocumentClick,
          touchstart: this.handleDocumentClick
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this4 = this;

      if (prevState.active && !this.state.active) {
        if (this.props.onHide) setTimeout(function () {
          return _this4.props.onHide();
        }, 500);

        _utils.events.removeEventsFromDocument({
          click: this.handleDocumentClick,
          touchstart: this.handleDocumentClick
        });
      } else if (!prevState.active && this.state.active && this.props.onShow) {
        this.props.onShow();
      }

      if (prevProps.children.length !== this.props.children.length) {
        var _this$menuNode$getBou = this.menuNode.getBoundingClientRect(),
            width = _this$menuNode$getBou.width,
            height = _this$menuNode$getBou.height;

        this.setState({
          width: width,
          height: height
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.active) {
        _utils.events.removeEventsFromDocument({
          click: this.handleDocumentClick,
          touchstart: this.handleDocumentClick
        });
      }

      clearTimeout(this.positionTimeoutHandle);
      clearTimeout(this.activateTimeoutHandle);
    }
  }, {
    key: "getRootStyle",
    value: function getRootStyle() {
      return this.state.position !== POSITION.STATIC ? {
        height: this.state.height
      } : undefined;
    }
  }, {
    key: "calculatePosition",
    value: function calculatePosition() {
      var _ReactDOM$findDOMNode = _reactDom["default"].findDOMNode(this),
          parentNode = _ReactDOM$findDOMNode.parentNode;

      if (!parentNode) return undefined;

      var _parentNode$getBoundi = parentNode.getBoundingClientRect(),
          top = _parentNode$getBoundi.top,
          left = _parentNode$getBoundi.left,
          height = _parentNode$getBoundi.height,
          width = _parentNode$getBoundi.width;

      var _getViewport = (0, _utils2.getViewport)(),
          wh = _getViewport.height,
          ww = _getViewport.width;

      var toTop = top < wh / 2 - height / 2;
      var toLeft = left < ww / 2 - width / 2;
      return "".concat(toTop ? 'top' : 'bottom').concat(toLeft ? 'Left' : 'Right');
    }
  }, {
    key: "show",
    value: function show() {
      var _this$menuNode$getBou2 = this.menuNode.getBoundingClientRect(),
          width = _this$menuNode$getBou2.width,
          height = _this$menuNode$getBou2.height;

      this.setState({
        active: true,
        width: width,
        height: height
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.setState({
        active: false
      });
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this5 = this;

      return _react["default"].Children.map(this.props.children, function (item) {
        if (!item) return item;

        if (item.type === _MenuItem["default"]) {
          return _react["default"].cloneElement(item, {
            selected: typeof item.props.value !== 'undefined' && _this5.props.selectable && item.props.value === _this5.props.selected,
            onClick: _this5.handleSelect.bind(_this5, item)
          });
        }

        return _react["default"].cloneElement(item);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames,
          _this6 = this;

      var theme = this.props.theme;
      var outlineStyle = {
        height: this.state.height,
        width: '100%'
      };
      var className = (0, _classnames2["default"])([theme.menu, theme[this.state.position]], (_classnames = {}, _defineProperty(_classnames, theme.active, this.state.active), _defineProperty(_classnames, theme.rippled, this.state.rippled), _classnames), this.props.className);
      var innerMenuClassName = (0, _classnames2["default"])(theme.menuInner, this.props.innerDropdownClassName);
      return _react["default"].createElement("div", {
        "data-react-toolbox": "menu",
        className: className,
        style: this.getRootStyle()
      }, this.props.outline ? _react["default"].createElement("div", {
        className: theme.outline,
        style: outlineStyle
      }) : null, _react["default"].createElement("ul", {
        ref: function ref(node) {
          _this6.menuNode = node;
        },
        className: innerMenuClassName
      }, this.renderItems()));
    }
  }]);

  return Menu;
}(_react.Component);

exports.Menu = Menu;

_defineProperty(Menu, "propTypes", {
  active: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  onHide: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  onShow: _propTypes["default"].func,
  outline: _propTypes["default"].bool,
  position: _propTypes["default"].oneOf(Object.keys(POSITION).map(function (key) {
    return POSITION[key];
  })),
  selectable: _propTypes["default"].bool,
  selected: _propTypes["default"].node,
  theme: _propTypes["default"].shape({
    active: _propTypes["default"].string,
    bottomLeft: _propTypes["default"].string,
    bottomRight: _propTypes["default"].string,
    menu: _propTypes["default"].string,
    menuInner: _propTypes["default"].string,
    outline: _propTypes["default"].string,
    rippled: _propTypes["default"].string,
    "static": _propTypes["default"].string,
    topLeft: _propTypes["default"].string,
    topRight: _propTypes["default"].string
  })
});

_defineProperty(Menu, "defaultProps", {
  active: false,
  outline: true,
  position: POSITION.STATIC,
  selectable: true
});

var _default = (0, _ThemeProvider.applyTheme)('Menu', Menu);

exports["default"] = _default;